import React, { useRef, useState } from "react";
import { TextField } from "@mui/material";
import { DetailedRequisitionSerializer } from "../../recoil/types";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";

import {
  GeneralInfoText,
  GeneralInfoWrapper,
  UserReportInternalNotesButtons,
  UserReportInternalNotesMessage,
} from "./UserReport.styles";

import { Button } from "../shared/Button/Button";
import { setUpdatedInternalNotes } from "./Services/UserReportService";
import { NewReqBillingRadioTreatmentNotesWrapper } from "../NewRequisition/NewRequisition.styles";
import { SpinnerLoading } from "../shared/Spinner/SpinnerLoading";
import { useAuthenticationHook } from "../../utils/hooks/useAuthenticationHook";

const InternalNotes: React.FC<{
  fullReport: DetailedRequisitionSerializer;
  setFullReport: React.Dispatch<
    React.SetStateAction<DetailedRequisitionSerializer | undefined>
  >;
}> = ({ fullReport, setFullReport }) => {
  const { deviceType } = useDeviceHook();
  const notesFieldReference = useRef<HTMLInputElement | null>(null);
  const [internalNotes, setInternalNotes] = useState<string>(
    fullReport.internal_notes || "",
  );

  const [loading, setLoading] = useState<boolean>(false);

  const { auth, setLoggedOut } = useAuthenticationHook();

  return (
    <GeneralInfoWrapper>
      <GeneralInfoText id="req-treatment-notes">INTERNAL NOTES</GeneralInfoText>
      <NewReqBillingRadioTreatmentNotesWrapper deviceType={deviceType}>
        <UserReportInternalNotesMessage>
          Used by internal staff of your clinic, not visible to patients, and
          not monitored by BillionToOne
        </UserReportInternalNotesMessage>
        <TextField
          inputRef={notesFieldReference}
          value={internalNotes}
          onChange={(e) => {
            setInternalNotes(e.target.value);
          }}
          label=""
          rows={7}
          multiline
          fullWidth
        />
        <UserReportInternalNotesButtons>
          {loading ? (
            <SpinnerLoading />
          ) : (
            <Button
              label="SAVE"
              onClick={async () => {
                if (
                  internalNotes !== fullReport.internal_notes &&
                  fullReport.sfid &&
                  auth
                ) {
                  setLoading(true);
                  const updatedReport = await setUpdatedInternalNotes(
                    internalNotes,
                    fullReport.sfid,
                    auth.token,
                    setLoggedOut,
                  );
                  setLoading(false);
                  if (updatedReport) {
                    setFullReport(updatedReport);
                  }
                }
              }}
              disabled={
                !internalNotes || internalNotes === fullReport.internal_notes
              }
              size="small"
            />
          )}
          <Button
            label="CANCEL"
            onClick={() => {
              setInternalNotes(fullReport.internal_notes || "");
            }}
            size="small"
            reverse
            disabled={
              !internalNotes || internalNotes === fullReport.internal_notes
            }
          />
        </UserReportInternalNotesButtons>
      </NewReqBillingRadioTreatmentNotesWrapper>
    </GeneralInfoWrapper>
  );
};

export default InternalNotes;
